var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Server status: "+_vm._s(_vm.status))]),_c('button',{on:{"click":function($event){_vm.changeStatus()}}},[_vm._v("Change")])])}
var staticRenderFns = []

export { render, staticRenderFns }